// Gamified cart-level discount tiers — must match backend (routes_commerce.py).
// All percentages apply to the FULL cart subtotal based on TOTAL item quantity.
export const MOQ = 5; // Minimum order quantity to enable checkout

export const DISCOUNT_TIERS = [
  { qty: 1,   pct: 2,  label: "Welcome",   tone: "🎁" },
  { qty: 5,   pct: 5,  label: "Starter",   tone: "🥉" },
  { qty: 10,  pct: 6,  label: "Bronze",    tone: "🥉" },
  { qty: 20,  pct: 7,  label: "Silver",    tone: "🥈" },
  { qty: 30,  pct: 8,  label: "Gold",      tone: "🥇" },
  { qty: 40,  pct: 9,  label: "Platinum",  tone: "💎" },
  { qty: 50,  pct: 10, label: "Diamond",   tone: "💎" },
  { qty: 100, pct: 15, label: "Elite",     tone: "👑" },
];

export const FREE_SHIPPING_QTY = 50;
export const FREE_SHIPPING_SUBTOTAL = 699;

export const getCurrentTier = (totalQty = 0) => {
  let current = null;
  for (const t of DISCOUNT_TIERS) {
    if (totalQty >= t.qty) current = t;
  }
  return current; // null if totalQty === 0
};

export const getNextTier = (totalQty = 0) => {
  for (const t of DISCOUNT_TIERS) {
    if (totalQty < t.qty) return t;
  }
  return null; // maxed out
};

export const getDiscountPct = (totalQty = 0) => {
  const t = getCurrentTier(totalQty);
  return t ? t.pct : 0;
};
